/**
 * Custom Variant List
 * Displays variant metafield data in a list format
 * Requires: variant-data-processor.js to be loaded first
 */

document.addEventListener('DOMContentLoaded', function() {
  // Get configuration from the list container's data attributes
  const listContainer = document.getElementById('prsp-list');
  if (!listContainer) return;

  const ns = listContainer.dataset.ns || 'prsp';
  const currentVariant = parseInt(listContainer.dataset.currentVariant) || null;

  let lastVariantId = null;
  let initialized = false;

  function slugToLabel(string) {
    return string.replace(/_/g, ' ').replace(/(?: |\b)(\w)/g, function(key) { return key.toUpperCase() });
  }

  function updateList(variantId) {
    if (!listContainer) {
      console.error('List container not found');
      return;
    }

    const variant = window.prsp_variants[variantId];
    if (!variant) {
      console.error('Variant data not found:', variantId);
      return;
    }

    listContainer.innerHTML = '';

    const defaultOrder = `attribute_flavour_1 @Flavour
LINEBREAK
tw_format @Format
LINEBREAK
tw_strength_grouping @Strength Group`;
    const orderRaw = (window.prsp_metafieldsOrderRaw || '').trim() || defaultOrder;
    const order = orderRaw.trim().split('\n');

    // Track which fields we've already added and limit to 7
    const addedFields = new Set();
    let itemCount = 0;
    const maxItems = 7;

    // Process fields in order, skip LINEBREAK, and stop at 7 items
    order.forEach(field => {
      if (itemCount >= maxItems) return;
      if (field.trim() === 'LINEBREAK') return;

      const { key } = window.prsp_extractField(field);

      if (!addedFields.has(key)) {
        const metafield = variant.metafields[key];

        if (metafield && metafield.value != null && String(metafield.value).trim() !== '') {
          const value = String(metafield.value);
          const icon = metafield.icon || '';
          itemCount++;

          listContainer.innerHTML += `
            <div class="${ns}-item" data-metafield-key="${key}" data-prsp-slot="${itemCount}" data-testid="prsp-spec-item">
              <div class="${ns}-item-icon">${icon}</div>
              <div class="${ns}-item-value">${value}</div>
            </div>`;

          addedFields.add(key);
        }
      }
    });

    listContainer.dataset.prspSlotCount = String(itemCount);
  }

  function updateAddToCartButtonText(variantId) {
    const addToCartButton = document.querySelector('.product-info__add-button button[name="add"]');
    if (!addToCartButton) return;

    const originalText = addToCartButton.dataset.addToCartText;
    if (!originalText) return;

    const currentText = addToCartButton.textContent;
    if (currentText && currentText.includes(' - ') && currentText.startsWith(originalText)) {
      return;
    }

    if (!addToCartButton.disabled) {
      addToCartButton.textContent = originalText;
    }
  }

  function initialize() {
    if (initialized) return;
    initialized = true;

    function handleVariantChange(variantId) {
      const selectedVariantId = parseInt(variantId);
      if (!selectedVariantId || selectedVariantId === lastVariantId) return;

      lastVariantId = selectedVariantId;
      if (!window.prsp_variants[selectedVariantId]) {
        console.error('Variant not found:', selectedVariantId);
        return;
      }
      updateList(selectedVariantId);
      updateAddToCartButtonText(selectedVariantId);
    }

    // Try to find the product form for variant change listening
    const pForm = document.querySelectorAll('.js-product-form-main')[0];
    if (pForm) {
      pForm.addEventListener('change', function() {
        const formInput = document.querySelector('.js-product-form-main input[name="id"]');
        handleVariantChange(formInput ? formInput.value : currentVariant);
      });
    }

    // Listen for the custom on:variant:change event dispatched by both the
    // legacy variant-picker and the new-variant-picker (which updates the
    // hidden form input programmatically without firing a change event).
    const section = listContainer.closest('.js-product') || document;
    section.addEventListener('on:variant:change', function(e) {
      const variantId = e.detail && e.detail.variant ? e.detail.variant.id : null;
      if (variantId) handleVariantChange(variantId);
    });

    // Initialize with the variant displayed as selected. Prefer the
    // new-variant-picker's checked radio (which reflects what the user
    // actually sees as selected) over the product form's hidden input
    // (which may still hold the default variant on initial page load
    // if the picker auto-selected a different first-available variant).
    const checkedPicker = document.querySelector('.new-variant-picker__input:checked');
    const formInput = document.querySelector('.js-product-form-main input[name="id"]');
    const pickerVariantId = checkedPicker ? parseInt(checkedPicker.value) : null;
    const formVariantId = formInput ? parseInt(formInput.value) : null;
    const initialVariantId = pickerVariantId || formVariantId || currentVariant;

    if (window.prsp_variants && window.prsp_variants[initialVariantId]) {
      updateList(initialVariantId);
    } else {
      console.error('Initial variant not found:', initialVariantId);
    }

    // Update button text initially (only if form exists)
    if (pForm) {
      updateAddToCartButtonText(initialVariantId);
    }
  }

  // Initialize when variant data is ready
  if (window.prsp_variants) {
    initialize();
  } else {
    window.addEventListener('prsp_variants_ready', initialize);
  }
});
